<template>
  <Head title="Dokumen" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Dokumen', href: route('documents.index') },
          ]"
        />

        <div
          class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
        >
          <div></div>
        </div>

        <!-- Main Grid Layout -->
        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <!-- Form Section (Left) uses FormAddDokumen.vue -->
          <div class="lg:col-span-1">
            <div
              class="p-6 bg-white border rounded-lg shadow-sm border-slate-200"
            >
              <h2 class="mb-6 text-lg font-semibold text-slate-900">
                Tambah Dokumen
              </h2>
              <FormAddDokumen
                :isOpen="true"
                title="Tambah Dokumen"
                :jenis="props.jenis"
              />
            </div>
          </div>
          <!-- Table Section (Right) -->
          <div class="lg:col-span-2">
            <!-- Search Input -->
            <div class="relative mb-4 text-sm text-slate-800">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none text-slate-400"
              >
                <MagnifyingGlassVue />
              </div>
              <input
                v-model="search"
                type="text"
                autocomplete="off"
                placeholder="Cari Nama Dokumen"
                id="search"
                class="block w-full py-2 pl-10 transition-colors duration-200 border-0 rounded-lg text-slate-900 ring-1 ring-inset ring-slate-200 placeholder:text-slate-400 focus:ring-2 focus:ring-inset focus:ring-maroon-600 sm:text-sm sm:leading-6"
              />
            </div>

            <!-- Desktop Table (Dokumen) -->
            <div class="hidden overflow-x-auto md:block">
              <table
                class="min-w-full bg-white border rounded-lg shadow-sm border-slate-200"
              >
                <thead class="bg-slate-50">
                  <tr>
                    <th
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-slate-900 sm:pl-6"
                    >
                      No
                    </th>
                    <th
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-slate-900 sm:pl-6"
                    >
                      Nama Dokumen
                    </th>
                    <th
                      class="px-3 py-3.5 text-left text-sm font-semibold text-slate-900"
                    >
                      Jenis Dokumen
                    </th>
                    <th
                      class="px-3 py-3.5 text-left text-sm font-semibold text-slate-900"
                    >
                      Kategori
                    </th>
                    <th class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span class="sr-only">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-slate-200">
                  <tr
                    v-for="(dok, index) in dokumens?.data || []"
                    :key="dok.id"
                    class="hover:bg-slate-50"
                  >
                    <td class="px-3 py-4 text-slate-500 whitespace-nowrap">
                      {{
                        ((dokumens?.current_page || 1) - 1) *
                          (dokumens?.per_page || 10) +
                        index +
                        1
                      }}
                    </td>
                    <td
                      class="px-3 py-4 break-words whitespace-normal text-slate-700"
                    >
                      {{ dok.nama_dok || "-" }}
                    </td>
                    <td class="px-3 py-4 text-slate-700 whitespace-nowrap">
                      {{ dok.jenisdokumen?.nama || "-" }}
                    </td>
                    <td class="px-3 py-4 text-slate-700 whitespace-nowrap">
                      {{ dok.status == 1 ? "Internal" : "Eksternal" }}
                    </td>
                    <td
                      class="relative py-4 pl-3 pr-4 text-right whitespace-nowrap sm:pr-6"
                    >
                      <div class="flex justify-end space-x-2">
                        <Link
                          :href="`/documents/${dok.iddok}`"
                          class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                        >
                          <EditIcons class="w-3 h-3" />
                          <span class="hidden ml-1 sm:inline">Edit</span>
                        </Link>
                        <button
                          @click="deleteDoc(dok.id)"
                          class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 hover:text-red-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                          title="Delete"
                        >
                          <DeleteIcons class="w-3 h-3" />
                          <span class="hidden ml-1 sm:inline">Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mobile Cards (Dokumen) -->
            <div class="space-y-4 md:hidden">
              <div
                v-for="dok in dokumens?.data || []"
                :key="dok.id"
                class="p-4 bg-white border rounded-lg shadow-sm border-slate-200"
              >
                <div class="flex items-start justify-between">
                  <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium break-words text-slate-900">
                      {{ dok.nama_dok || "-" }}
                    </p>
                    <p class="text-xs text-slate-500">
                      {{ dok.program?.name || dok.prodi_name || "-" }}
                    </p>
                    <p class="text-xs text-slate-500">
                      {{ dok.status == 1 ? "Internal" : "Eksternal" }}
                    </p>
                  </div>
                  <div class="flex space-x-2">
                    <Link
                      v-if="$page.props.can.dokumen_edit"
                      :href="`/documents/${dok.id}`"
                      class="p-2 border rounded-md text-maroon-600 border-maroon-200 hover:bg-maroon-50"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <Pagination
              :data="dokumens"
              :updatedPageNumber="updatedPageNumber"
            />
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { usePage, router, Link } from "@inertiajs/vue3";
import { ref, computed, watch } from "vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Header from "@/Components/Header.vue";
import Container from "@/Layouts/Container.vue";
import FormAddDokumen from "@/Components/Dokumen/FormAddDokumen.vue";
import DeleteIcons from "@/Components/Icons/DeleteIcons.vue";
import EditIcons from "@/Components/Icons/EditIcons.vue";
import Pagination from "@/Components/Pagination.vue";
const props = defineProps({
  dokumens: {
    type: Object,
    required: true,
  },
  jenis: {
    type: Object,
    required: true,
  },
});

// Search and pagination (server-side like original, compatible with backend)
let search = ref(usePage().props.search || "");
let pageNumber = ref(1);

let formasiUrl = computed(() => {
  let url = new URL(route("documents.index"));
  url.searchParams.set("page", pageNumber.value);
  if (search.value) {
    url.searchParams.set("search", search.value);
  }
  return url;
});

const updatedPageNumber = (link) => {
  const params = new URLSearchParams(link.url.split("?")[1]);
  pageNumber.value = params.get("page");
};

watch(
  () => formasiUrl.value,
  (updatedFormasiUrl) => {
    router.visit(updatedFormasiUrl.toString(), {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    });
  }
);

watch(
  () => search.value,
  (value) => {
    if (value) {
      pageNumber.value = 1;
    }
  }
);

const deleteDoc = (docId) => {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Dokumen ini akan dihapus secara permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      router.delete(route("documents.destroy", docId), {
        onSuccess: () => {
          Swal.fire({
            title: "Berhasil!",
            text: "Dokumen berhasil dihapus.",
            icon: "success",
            confirmButtonText: "OK",
          });
        },
        onError: () => {
          Swal.fire({
            title: "Gagal!",
            text: "Terjadi kesalahan saat menghapus dokumen.",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
        preserveScroll: true,
      });
    }
  });
};
</script>
